import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function AnalyticsListener() {
  const location = useLocation();

  useEffect(() => {
    // SPA page view tracking (GA4)
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      const pagePath = location.pathname + location.search;

      window.gtag("event", "page_view", {
        page_path: pagePath,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location]);

  return null;
}
